import { colorSet } from '@components/Provider';
import { makeStyles, Theme } from '@material-ui/core';
import { ImageGridProps } from './types';

const useStyles = makeStyles<
  Theme,
  Pick<ImageGridProps, 'borderRadius' | 'files' | 'maxHeight'>
>((theme) => {
  return {
    root: {
      display: 'flex',
      cursor: 'pointer',
      height: '100%',
      maxHeight: (props) => (props.maxHeight ? props.maxHeight : 200),
      flexWrap: 'nowrap',
      '& > :first-child': {
        width: (props) =>
          props.files.length <= 1 ? 'calc(100%)' : 'calc(100% / 2)'
      },
      '& > :last-child': {
        width: (props) =>
          props.files.length <= 1 ? 'calc(100%)' : 'calc(100% / 2)'
      },
      borderRadius: ({ borderRadius }) =>
        borderRadius ? `${borderRadius}px` : ''
    },
    coverRoot: {
      position: 'relative',
      minHeight: ({ maxHeight }) => (maxHeight ? maxHeight : 200),
      '& .cover-button': {
        position: 'absolute',
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        maxWidth: 124,
        height: 20,
        top: 12.5,
        left: 12,
        '& .text': {
          color: colorSet.gray000
        },
        '& svg': {
          color: colorSet.gray000,
          width: 20,
          height: 20,
          marginRight: 6
        }
      },
      '& > img': {
        minHeight: ({ maxHeight }) => (maxHeight ? maxHeight : 200),
        objectFit: 'cover',
        height: '100%',
        width: '100%'
      }
    },
    splitRoot: {
      position: 'relative',
      display: 'flex',
      flexWrap: 'wrap',
      '& > img': {
        objectFit: 'cover',
        minHeight: ({ maxHeight }) => (maxHeight ? maxHeight / 2 : 200),
        height: (props) => {
          if (props.files.length >= 3) {
            return '50%';
          }

          if (props.files.length <= 2) {
            return '100%';
          }
        },
        width: (props) => {
          if (props.files.length >= 5) {
            return '50%';
          }

          if (props.files.length === 4) {
            return '50%';
          }

          if (props.files.length === 3 || props.files.length === 2) {
            return '100%';
          }

          return '100%';
        },
        '&:first-child': {
          width: (props) => {
            if (props.files.length === 4) {
              return '100%';
            }
          }
        }
      },
      '& .overlay': {
        position: 'relative',
        width: '50%',
        height: '50%',

        '& > button': {
          padding: 0,
          borderRadius: 0,
          height: '100%',
          background:
            'linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))',
          minWidth: 'unset',
          '& > :first-child': {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            '& > svg': {
              zIndex: 1,
              color: colorSet.gray000,
              width: 20,
              height: 20
            },
            '& > p': {
              zIndex: 1,
              color: colorSet.gray000
            }
          }
        },
        '& > img': {
          position: 'absolute',
          zIndex: 0,
          objectFit: 'cover',
          height: '100%',
          width: '100%'
        }
      }
    },
    radius: {
      '&.all': {
        borderRadius: ({ borderRadius }) =>
          borderRadius ? `${borderRadius}px` : ''
      },
      '&.left': {
        borderRadius: ({ borderRadius }) =>
          borderRadius ? `${borderRadius}px 0px 0px ${borderRadius}px` : ''
      },
      '&.right': {
        borderRadius: ({ borderRadius }) =>
          borderRadius ? `0px ${borderRadius}px ${borderRadius}px 0px` : ''
      },
      '&.top-right': {
        borderTopRightRadius: ({ borderRadius }) =>
          borderRadius ? `${borderRadius}px` : ''
      },
      '&.bottom-right': {
        borderBottomRightRadius: ({ borderRadius }) =>
          borderRadius ? `${borderRadius}px !important` : ''
      }
    },
    overlay: {
      opacity: 0.3,
      background: `linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))`,
      position: 'absolute',
      width: '100%',
      height: '100%',
      borderRadius: ({ borderRadius }) =>
        borderRadius ? `${borderRadius}px 0px 0px ${borderRadius}px` : ''
    }
  };
});

export default useStyles;
